<template>
  <ChartLine v-if="(visible && fetchResult.length)" id='altitudeChart' :label="t('Altitude [m]')" data0Color="#fbd604" :data="fetchResult" :fill="false" :showLine1="false"/>
</template>

<script setup>
import { ref, defineExpose } from 'vue'
import ChartLine from "./ChartLine.vue"
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
const fetchResult = ref([])
const visible = ref(false)

defineExpose({
  visible,
  fetchResult,
});

</script>

<i18n>
    {
      "pl": {
        "Altitude [m]": "Wysokość [m]",
      }
    }
</i18n>
